module.exports = __webpack_public_path__ + "static/media/php-original.7be7348e.svg";